import { Flex } from 'antd';
import styled from 'styled-components';
import { focusHaloBleed } from '../../assets/styles/components/scrollGutter';

export const PeriodSummary = styled(Flex)`
  padding: var(--spacing-gutter);
  border: 1px solid var(--clr-general-border-hover);
  border-radius: 5px;
  background-color: var(--clr-general-hover);
`;

/** Not `.status-chip`: that rule is scoped to PrimaryCard, and this renders in a modal outside it. */
export const PeriodTypeChip = styled(Flex)`
  padding: 4px 15px;
  border-radius: 30px;
  min-height: 23px;
  background-color: var(--tag-toast-error);
  color: var(--clr-title);
  font-size: 10px;
  line-height: 100%;
  white-space: nowrap;
`;

export const PeriodDivider = styled.div`
  height: 1px;
  background-color: var(--selected-hover);
`;

/** Two tabs that share the dialog's width, with the strip's rule kept inside the dialog's padding. */
export const CreationTabs = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  /* A scroll area clips sideways too, so a full-width field's focus halo needs the room. */
  ${focusHaloBleed}
  && .ant-tabs-nav {
    /* The dialog header already leaves 15px above the chips. */
    --pill-row-top: 0px;
    --pill-row-bottom: 15px;
    margin-inline: 0;
    .custom-tabs-strip-gutter {
      width: 0;
    }
    .ant-tabs-nav-list {
      width: 100%;
    }
    .ant-tabs-tab {
      flex: 1 1 0;
      justify-content: center;
    }
  }
`;
